interface DraftBannerProps {
  epic: string;
  run: string;
  subtitle?: string;
}

export function DraftBanner({ epic, run, subtitle }: DraftBannerProps) {
  return (
    <div
      role="status"
      className="flex flex-col gap-1 rounded-lg border border-[var(--warning)]/40 bg-[var(--warning-bg)] px-4 py-3 text-sm text-[var(--warning)]"
    >
      <div className="flex flex-wrap items-center gap-2">
        <span className="rounded-full border border-[var(--warning)]/40 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide">
          {epic}
        </span>
        <p className="font-semibold">
          Draft — generated by handover {run}. Mock data; nothing here saves.
        </p>
      </div>
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
}
